import { render } from "./FrontPageDesignGallery.vue?vue&type=template&id=0666769e&scoped=true"
import script from "./FrontPageDesignGallery.vue?vue&type=script&lang=js"
export * from "./FrontPageDesignGallery.vue?vue&type=script&lang=js"

import "./FrontPageDesignGallery.vue?vue&type=style&index=0&id=0666769e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0666769e"]])

export default __exports__